import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function currentPageReducer(state = initialState.currentPage, action){
    console.log('currentPageReducer', action);
    switch(action.type){
      case types.SET_CURRENT_PAGE:
        return Object.assign({}, state, {
          isLoading: false,
          permalink: action.permalink
        });
      case types.SET_CURRENT_POST_ID:
        return Object.assign({}, state, {
          postId: parseInt(action.postId, 10)
        })
      case types.SET_CURRENT_PAGE_LOADING:
        return Object.assign({}, state, {
          isLoading: action.isLoading
        });
      case types.SET_SHOULD_TRY_AUTOLOADING:
        return Object.assign({}, state, {
          shouldTryAutoloading: action.shouldTryAutoloading
        });
      default:
        return state;
    }
}
